<template>
  <!-- 切换语言 -->
  <el-dropdown trigger="click">
    <span class="flex-center el-dropdown-link">
      <img :src="current.img" style="width: 32px; height: auto; margin-right: 10px" />
      <strong>{{ current.name }}</strong>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="lang in loadedLanguages"
        :key="lang.name"
        :disabled="currentLang == lang.value"
        @click.native="setLang(lang.value)"
      >
        <div class="flex-center el-dropdown-item">
          <img :src="lang.img" style="width: 32px; height: auto; padding: 3.57px" />
          {{ lang.name }}
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import i18nMixin from '@/store/i18n-mixin';

export default {
  data() {
    return {
      loadedLanguages: [
        {
          name: '简体',
          value: 'zh',
          img: require('@/assets/images/zh.png')
        },
        {
          name: 'English',
          value: 'en',
          img: require('@/assets/images/en.png')
        },
        {
          name: 'Tiếng Việt',
          value: 'vi',
          img: require('@/assets/images/vi.png')
        }
      ]
    };
  },
  computed: {
    current() {
      return this.loadedLanguages.find(({ value }) => this.currentLang === value);
    }
  },
  mixins: [i18nMixin]
};
</script>

<style lang="scss" scoped>
/deep/ .flex-center {
  display: flex;
  align-items: center;
}
/deep/ .el-dropdown-link {
  box-sizing: border-box;
  padding: 12px 16px;
  height: 48px;
  color: var(--color-gray-700, #ffffff);
  /* Text md/Medium */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  //font-weight: 500;
  display: flex;
  justify-content: center;
  border: 1px solid #ffffff;
  border-radius: 4px;
}
/deep/ .el-popper[x-placement^='bottom'] {
  border-radius: 8px;
  background: var(--color-white, #fff);
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
}
/deep/ .el-dropdown-item {
  /* Text md/Medium */
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  // font-weight: 500;
  line-height: 24px; /* 150% */
}
/deep/ .el-dropdown-menu__item {
  padding-left: 0;
  padding-right: 30px;
  margin: 0 2px;
  &:hover {
    border-radius: 6px;
    background: var(--color-light-green, #ecfbf3);
    color: var(--color-gray-700, #606266);
  }
}
strong {
  font-weight: 400;
  font-size: 20px;
  margin-right: 10px;
  height: 24px;
  line-height: 24px;
  font-family: FZBeiWeiKaiShu-S19S;
}
</style>



// WEBPACK FOOTER //
// src/components/cuscom/select-lang/lang-vip.vue